import React, { Component } from 'react'
import { Config } from '../Config';
import rodape from './../images/Rodape_Logos.jpg'
import cebraspe_cinza from './../images/cebraspe_cinza.png'
import Loading from './Loading';
import $ from 'jquery'

class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuInformacoes: [],
            menuServicos: [],
            menuInstitucional: [],
            loading: true,
            footerHtml: ''
        }
    }

    componentDidMount() {
        
        $.get("../index.html", (data) => {

            var pathAtual = window.location.pathname;
            var partesPath = pathAtual.split('/');         

            var pathAtualAjustado = '/' + partesPath[1];

            var html = $(data);
            var footer = $('footer', html);
            var innerHtml = footer.html();

            $("img", html).each(function () {
                this.src = this.src.replace(pathAtualAjustado, '');               
            });

            $("a", footer).each(function () {
                this.href = this.href.replace(pathAtualAjustado,'');               
            });

            $("img", footer).each(function () {
                this.src = this.src.replace(pathAtualAjustado, '');              
            });

            $(".footer_bottom_holder", footer).remove();              

            this.setState({
                footerHtml: footer.html(),
                loading: false
            });        
        });
    }   

    render() {   

        const { loading } = this.state;
        if (loading) {
            return (<Loading></Loading>);
        }
        return (
            <footer dangerouslySetInnerHTML={{ __html: this.state.footerHtml }} />
        )
    }
}

export default Footer













